import styled, { keyframes } from "styled-components";


const expansion = () => keyframes`
 0% {
  box-shadow: 0 0 0 0px rgba(255,0,0,.5);
 }
 100% {
  box-shadow: 0 0 0 5px rgba(255,0,0,.5);
 }
`

export const FlorenzInputDate = styled.div`
  width: -webkit-fill-available;
  display: flex;
  align-items: center;
  .label {
    display: flex;
    align-items: center;
    margin-right: 10px;
    &__text {
      color: #1F1F52;
      margin-right: 10px;
      font-size: 17px;
    }
    &__required {
      width: 7px;
      color: #FF5757;
    }
    &__icon {
      color: #1F1F52;
      font-size: 7px;
    }
  }
  .input-container {
    background-color: ${({disabled, forWhiteBackgroud}) => 
      disabled 
        ? "#CFD3DD" 
        : forWhiteBackgroud 
          ? "#F0F0FF" 
          : "#FFFFFF"
    };
    border: none;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    min-width: 100px;
    position: relative;
    padding: 12.5px 10px;
    border-radius: 14px;
    cursor: ${({disabled}) => disabled ? '' : 'text'};
    &:focus-within {
      .numeral {
        color: #2A28D6;
      }
    }
    input {
      border: none;
      background-color: transparent;
      width: 100%;
      font-family: "Nunito Sans Light";
      font-size: 18px;
      color: ${({disabled}) => disabled ? "#707582 important!" : "#1F1F52"};
      text-transform: uppercase;
      &:focus {
        outline: none;
        color: #2A28D6;
      }
      &::placeholder { 
        color: #707582;
        font-size: 18px;
        font-family: "Nunito Sans";
      }
      &::-webkit-scrollbar {
          height: 4px;
          width: 20px;
          margin: 0;
          opacity: .9;
          padding-bottom: 10px;
          cursor: pointer;
        }
        ::-webkit-scrollbar-track {
          min-height: 5px !important;
        }
        ::-webkit-scrollbar-thumb {
          min-height: 30px !important;
        }

    }
    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
      -webkit-appearance: none; 
      margin: 0; 
    }
  }
`